import { render, staticRenderFns } from "./wzzyy.vue?vue&type=template&id=0dcd1462"
import script from "./wzzyy.vue?vue&type=script&lang=js"
export * from "./wzzyy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports